import type { SVGProps } from 'react';

export function WarningIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#warning-icon-clip)">
        <path
          d="M10.0002 4.98906L16.2752 15.8307H3.72516L10.0002 4.98906ZM10.0002 1.66406L0.833496 17.4974H19.1668L10.0002 1.66406ZM10.8335 13.3307H9.16683V14.9974H10.8335V13.3307ZM10.8335 8.33073H9.16683V11.6641H10.8335V8.33073Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="warning-icon-clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

